<template>
  <div class="comment">
    <div class="title" @click="$router.push(`/product/${$route.params.id}/comment`)">
      商品评价
      <div class="btn">共{{ comments.total }}条</div>
      <van-icon name="arrow" />
    </div>
    <bm-comment :data="comments.list[0]" v-if="comments.list.length > 0" />
    <bm-comment :data="comments.list[1]" v-if="comments.list.length > 1" />
  </div>
</template>

<script>
export default {
  props: ['pid'],
  data() {
    return {
      comments: {
        show: false,
        list: [],
        total: 0,
        loading: false
      }
    }
  },
  mounted() {
    this.getComment()
  },
  watch: {
    pid(v) {
      this.getComment()
    }
  },
  methods: {
    getComment(page = 1) {
      this.comments.loading = true
      this.$api.admin
        .getComment({ productId: this.$route.params.id, page })
        .then(res => {
          if (page === 1) this.comments.list = []
          res.list.map(item => {
            this.comments.list.push(item)
          })
          this.comments.total = res.total
          this.comments.loading = false
        })
        .finally(() => {
          this.comments.loading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.comment {
  padding: 0;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
  z-index: 9;
  user-select: none;
  .title {
    padding: 15px;
    font-size: 16px;
    font-weight: bold;
    color: #343434;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    &:active {
      filter: brightness(95%);
    }
    .btn {
      flex: 1;
      text-align: right;
      font-size: 14px;
      font-weight: 500;
      background-color: #fff;
      padding: 2.5px 10px;
      border-radius: 8px;
      .icon {
        width: 10px;
        height: 10px;
      }
    }
  }
}
</style>
